import React, { useContext } from 'react'
import classNames from 'classnames'
import { PropTypes } from 'prop-types'
import Button from 'components/UI/Button'
import { ContextMenuContext } from 'components/Navigation/ContextMenu/ContextMenuLogic'

import './context-menu-container.pcss'

const ContextMenuContainer = ({ children, className, disableBackdrop }) => {
    const context = useContext(ContextMenuContext)

    return (
        <>
            <div className={classNames('context-menu-container', className)}>
                {children}
            </div>
            {!disableBackdrop && (
                <div className="context-menu-container-overlay animated fadeIn fastest">
                    <Button
                        className="context-menu-container-overlay__button"
                        trackName="contextMenuBackdrop"
                        onClick={context && ((e) => {
                            e.preventDefault()
                            context.onClickOutside()
                        })}
                    />
                </div>
            )}
        </>
    )
}

ContextMenuContainer.propTypes = {
    onClick: PropTypes.bool,
    className: PropTypes.string,
    disableBackdrop: PropTypes.bool,
}

export default ContextMenuContainer
